import { css } from '@emotion/css';
import React, { forwardRef, ForwardedRef } from 'react';
import { Form, FormCheckProps } from 'react-bootstrap';
import { generateRandomString } from '../consts';
import HelperText, { HelperTextProps } from '../Form/HelperText';

export interface CheckboxProps
  extends Omit<FormCheckProps, 'children'>,
    HelperTextProps {
  /** 欄位名稱(改為 required) */
  name: string;
}

const Checkbox = forwardRef(
  (props: CheckboxProps, ref: ForwardedRef<HTMLInputElement>): JSX.Element => {
    const {
      id = generateRandomString(12),
      custom = false,
      error,
      helperText,
      inline,
      className,
      style,
      ...other
    } = props;

    const styleToClass = css({
      ...(inline && {
        display: 'inline-block',
        marginRight: '1rem',
        verticalAlign: 'top',
      }),
      ...style,
    });

    return (
      <div className={(className ? `${className} ` : '') + styleToClass}>
        <Form.Check
          custom={custom}
          ref={ref}
          type="checkbox"
          id={id} // 有設定 id 點文字時才能觸發 onChange
          isInvalid={error}
          {...other}
        />
        <HelperText {...{ error, helperText }} />
      </div>
    );
  },
);

Checkbox.displayName = 'Checkbox';
export default Checkbox;
